/* Édition Mantra — logique panier (Mission 6)
   - Ajout : UN SEUL appel /cart/add.js avec les deux lignes
     (produit caché d'abord, produit principal ensuite : Shopify insère les
     nouvelles lignes en tête, le parent se retrouve donc AU-DESSUS).
   - Synchro : quantité du caché = quantité du parent × _perso_nb, liée par _perso_ref.
   - Garde-fou : une ligne cachée sans parent est supprimée au chargement.
   Chargé sur les fiches produit taggées (via le personalizer) et partout où
   le panier se rend (via cart-products.liquid). */
(function () {
  'use strict';
  if (window.OriiveMantraCart) return;

  var HANDLE_CACHE = 'personnalisation-mantra';
  var variantIdPromise = null;

  function hiddenVariantId() {
    if (!variantIdPromise) {
      variantIdPromise = fetch('/products/' + HANDLE_CACHE + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) { return p.variants[0].id; });
    }
    return variantIdPromise;
  }

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (c) {
      var id = c.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function applySections(sections) {
    if (!sections) return false;
    var applied = false;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.querySelector('cart-items-component[data-section-id="' + id + '"]') || tmp.querySelector('cart-items-component');
      var current = document.querySelector('cart-items-component[data-section-id="' + id + '"]');
      if (fresh && current) { current.replaceWith(fresh); applied = true; }
    });
    return applied;
  }

  function majCompteur() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('.cart-count,[data-cart-count],.cart-icon__count,cart-icon .count').forEach(function (el) { el.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
    }).catch(function () {});
  }

  function ouvrirDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      try { drawer.open(); return drawer.getBoundingClientRect().width > 0; } catch (e) {}
    }
    return false;
  }

  /* ---------- Ajout : deux lignes en un appel ---------- */
  function ajouterAvecPerso(form, perso) {
    var fd = new FormData(form);
    var mainId = parseInt(fd.get('id'), 10);
    var qty = parseInt(fd.get('quantity') || '1', 10) || 1;
    var props = {};
    fd.forEach(function (v, k) {
      var m = k.match(/^properties\[(.+)\]$/);
      if (m) props[m[1]] = v;
    });

    var btn = form.querySelector('.pdp2-atc');
    var btnHtml = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('disabled', ''); btn.textContent = 'Ajout en cours…'; }

    hiddenVariantId().then(function (hid) {
      var items = [
        { // ligne du produit caché — ajoutée en premier pour finir SOUS le parent
          id: hid,
          quantity: qty * perso.nb,
          properties: {
            'Mantra': perso.mantra,
            'Placement': perso.placement,
            '_perso_famille': perso.famille,
            '_perso_typo': perso.typo,
            '_perso_zone_bas': perso.zoneBas,
            '_perso_nb': String(perso.nb),
            '_perso_ref': perso.key
          }
        },
        { id: mainId, quantity: qty, properties: props }
      ];
      var body = { items: items };
      var ids = sectionIds();
      if (ids.length) body.sections = ids.join(',');
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      });
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      return r.json();
    }).then(function (res) {
      if (btn) { btn.removeAttribute('disabled'); btn.innerHTML = btnHtml; }
      applySections(res.sections);
      majCompteur();
      if (!ouvrirDrawer()) window.location.href = '/cart';
    }).catch(function () {
      if (btn) { btn.removeAttribute('disabled'); btn.innerHTML = btnHtml; }
      window.location.href = '/cart';
    });
  }

  /* ---------- Synchro + garde-fou ---------- */
  var enCours = false;

  function rafraichirPanier() {
    var ids = sectionIds();
    if (ids.length) {
      fetch(window.location.pathname + '?sections=' + encodeURIComponent(ids.join(',')))
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          if (!applySections(sections) && window.location.pathname.indexOf('/cart') === 0) window.location.reload();
          majCompteur();
        })
        .catch(function () { if (window.location.pathname.indexOf('/cart') === 0) window.location.reload(); });
    } else if (window.location.pathname.indexOf('/cart') === 0) {
      window.location.reload();
    } else {
      majCompteur();
    }
  }

  function synchroniser() {
    if (enCours) return;
    enCours = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var parents = {};
      cart.items.forEach(function (it) {
        var k = it.properties && it.properties._perso_key;
        if (k) parents[k] = it;
      });
      var ops = [];
      cart.items.forEach(function (it) {
        if (it.handle !== HANDLE_CACHE) return;
        var ref = it.properties && it.properties._perso_ref;
        var nb = parseInt((it.properties && it.properties._perso_nb) || '1', 10) || 1;
        var parent = ref ? parents[ref] : null;
        if (!parent) {
          ops.push({ id: it.key, quantity: 0 }); // orpheline → supprimée
        } else {
          var attendu = parent.quantity * nb;
          if (it.quantity !== attendu) ops.push({ id: it.key, quantity: attendu });
        }
      });
      if (!ops.length) { enCours = false; return; }
      var chaine = Promise.resolve();
      ops.forEach(function (op) {
        chaine = chaine.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(op)
          });
        });
      });
      chaine.then(function () { enCours = false; rafraichirPanier(); })
            .catch(function () { enCours = false; });
    }).catch(function () { enCours = false; });
  }

  var minuteur;
  function planifierSynchro() {
    clearTimeout(minuteur);
    minuteur = setTimeout(synchroniser, 300);
  }

  /* Toute mutation du panier par le thème (quantité, suppression, ajout)
     repasse par fetch : on resynchronise juste après. */
  var fetchOrigine = window.fetch;
  window.fetch = function () {
    var url = '';
    try { url = String(arguments[0] && arguments[0].url ? arguments[0].url : arguments[0] || ''); } catch (e) {}
    var promesse = fetchOrigine.apply(this, arguments);
    if (/\/cart\/(change|update|add)/.test(url)) {
      promesse.then(function () { planifierSynchro(); }).catch(function () {});
    }
    return promesse;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', synchroniser);
  } else {
    synchroniser();
  }

  window.OriiveMantraCart = {
    pret: true,
    ajouterAvecPerso: ajouterAvecPerso,
    synchroniser: synchroniser
  };
})();
